import {translateKnowledgeText} from '../../i18n/knowledgeTranslation';
import {useTranslation, localizeNewsTitle} from "../../i18n/translation";
import React from "react";
import {useLocation, Link} from "react-router-dom";
import {flattenStructure} from "./siteStructure";
import siteStructure from "../siteStructure.json";
import '../../css/navigation.css';
import {useNews} from "../news/NewsContext";
import {useTheme} from "../header/Header";
import knowledgeData from "../knowledge/knowledgeBaseData.json";

function controlNavigationLength(str, maxLength = 20) {
    if (str.length <= maxLength) return str;

    let truncated = str.substr(0, maxLength);

    const lastSpace = truncated.lastIndexOf(' ');

    if (lastSpace > 0) {
        truncated = truncated.substr(0, lastSpace);
    }

    return truncated + '...';
}

export default function Navigation() {
    const {english, t} = useTranslation();

    const {newsData} = useNews();
    const { theme } = useTheme();
    const location = useLocation();

    // Получаем текущий путь и разбиваем его на части
    const pathNames = location.pathname.replace(/^\/en(?=\/|$)/, "").split("/").filter((x) => x);

    // Создаем массив объектов для навигации
    const breadcrumbs = [
        {name: t("Главная"), path: english ? "/en" : "/"},
        ...pathNames.map((value, index) => ({
            name: controlNavigationLength(convertName(value, newsData, english, t), 40),
            path: `${english ? "/en" : ""}/${pathNames.slice(0, index + 1).join("/")}`,
        })),
    ];

    return (
        <div className="breadcrumbs-container">
            {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={breadcrumb.path}>
                 <span className={`breadcrumb-item ${theme}`}>
                    {/* Делать ссылку кликабельной, кроме последнего элемента */}
                     {index < breadcrumbs.length - 1 ? (
                         <Link to={breadcrumb.path}>{breadcrumb.name}</Link>
                     ) : (
                         <span>{breadcrumb.name}</span>
                     )}
                     {/* Добавляем стрелочку между элементами */}
                </span>
                    {index < breadcrumbs.length - 1 && <span className={`breadcrumb-item breadcrumb-separator ${theme}`}>/</span>}
                </React.Fragment>

            ))}
        </div>
    );
}

function convertName(name, newsData, english, t) {

    if (name === "knowledge-base") return english ? "Knowledge Base" : "База знаний";
    const knowledgeArticle = knowledgeData.articles.find(article => article.slug === name);
    if (knowledgeArticle) return english ? translateKnowledgeText(knowledgeArticle.title) : knowledgeArticle.title;

    const newsNavigation = {}

    newsData.forEach((e, i) => {
        newsNavigation[newsData.length - i] = localizeNewsTitle(e, english)
    })

    if(newsNavigation[name]){
        return newsNavigation[name]
    }

    const siteData = flattenStructure(siteStructure)
    if(siteData[name] && siteData[name].title) {
        return t(siteData[name].title)
    }

    return name; // Возвращаем исходное имя, если совпадений нет
}